import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {map, publishReplay, refCount} from 'rxjs/operators';

@Component({
  selector: 'cf-file-not-found',
  templateUrl: './file-not-found.component.html',
  styleUrls: ['./file-not-found.component.scss'],
})
export class FileNotFoundComponent implements OnInit {

  ref$: Observable<string>;
  fileId$: Observable<string>;
  fileName$: Observable<string>;
  deleted$: Observable<string>;
  error$: Observable<string>;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    const params$ = this.activatedRoute.queryParams.pipe(
      publishReplay(1), refCount(),
    );
    this.ref$ = params$.pipe(map(p => p.ref), publishReplay(1), refCount());
    this.fileId$ = params$.pipe(map(p => p.fileId), publishReplay(1), refCount());
    this.fileName$ = params$.pipe(map(p => p.name), publishReplay(1), refCount());
    this.deleted$ = params$.pipe(map(p => p.deleted), publishReplay(1), refCount());
    this.error$ = params$.pipe(map(p => p.error), publishReplay(1), refCount());
  }

}
